import { render, staticRenderFns } from "./AssurancePrevoyance.vue?vue&type=template&id=ab6943f8&"
import script from "./AssurancePrevoyance.vue?vue&type=script&lang=js&"
export * from "./AssurancePrevoyance.vue?vue&type=script&lang=js&"
import style0 from "./AssurancePrevoyance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports